<template>
    <div class="app flex-row align-items-center justify-content-center">
        <div class="d-flex flex-column">
            <span class="d-flex justify-content-center">
                <i class="fa fa-ban fa-5x" style="font-size: 6em"></i>
                <h1 class="display-4 align-self-center mx-4">
                    {{ $route.params.status }}
                </h1>
            </span>
            <div class="clearfix d-flex justify-content-center flex-column">
                <h4 class="pt-3 text-center">
                    {{ $t('serverErrors.danger') }}
                    {{ $t('serverErrors.somethingWentWrong') }}
                </h4>
                <p class="text-muted text-center" v-if="isErrorMessage">
                    {{ $t(`serverErrors.${httpErrorCode}`) }}
                </p>
                <b-button
                    class="mt-2"
                    variant="primary"
                    @click="$router.go(-2)"
                >
                    {{ $t('serverErrors.returnToPreviousPage') }}
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Error',
    data() {
        return {
            availableErrorMessages: ['403', '404'],
            httpErrorCode: this.$route.params.status,
        }
    },
    computed: {
        isErrorMessage() {
            return this.availableErrorMessages.includes(this.httpErrorCode)
        },
    },
    watch: {
        $route(route) {
            this.httpErrorCode = route.params.status
        },
    },
}
</script>
